"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _TableHead = _interopRequireDefault(require("@material-ui/core/TableHead"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function SttTableHead(props) {
  return /*#__PURE__*/_react["default"].createElement(_TableHead["default"], props);
}
var _default = SttTableHead;
exports["default"] = _default;